module.exports = __webpack_public_path__ + "media/images/application/template/video-modal-widget-bg-611d0211beca1040846c1c2de7973f51.png";